// extracted by mini-css-extract-plugin
export default {"container":"src-components-EditableTable-TableInput-css__container--i1Bk7"};